<template>
  <div class="relative">
    <hero :heading="heading" :subheading="subheading" />
    <app-section heading="Currently">
      <ul>
        <li class="mb-5">
          Full-time with
          <a class="link" href="https://unraid.net/">Unraid</a> working on
          multiple Vue.js
          <abbr title="Single Page Applications">SPAs</abbr>
          and maintaining a Craft CMS site with a full Commerce integration.
        </li>
        <li class="mb-5">
          <a
            class="link"
            href="https://open.spotify.com/user/zacktgizack"
            title="My Spotify Profile"
            >Listening</a
          >
          to
          <span v-if="!loading">{{ nowPlaying }}.</span>
          <span v-else>…loading Spotify data…</span>
        </li>
        <li>
          <a
            class="link"
            href="https://www.instagram.com/spear.zack/"
            title="My Instagram Profile"
            >Reminiscing</a
          >
          on recent adventures from here & there.
        </li>
      </ul>
    </app-section>
    <app-section heading="Featured Work">
      <project-list :projects="featuredProjects" />
      <app-button router-link="/work">View All Work</app-button>
    </app-section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppButton from "../components/Common/Button";
import Hero from "../components/Common/Hero";
import AppSection from "../components/Common/Section";
import ProjectList from "../components/Project/List";

/**
 * @name Home view
 */
export default {
  components: {
    AppButton,
    Hero,
    AppSection,
    ProjectList
  },
  data: () => ({
    heading:
      "Zack Spear is a full-stack web developer creating a plethora of internet things.",
    subheading:
      "Away from the mechanical keyboard he's using analog film cameras to help slow life down a little."
  }),
  computed: {
    ...mapGetters("work", ["featuredProjects"]),
    ...mapGetters("spotify", ["nowPlaying", "loading"])
  },
  created() {
    // prevents from fetch API data more than once per site visit
    if (this.loading) this.$store.dispatch("spotify/fetchLatestSong");
  }
};
</script>
